import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { POINTS_EVENT } from "@/components/PointsBurst";

const get = (p) => api.get(p).then((r) => r.data).catch(() => null);
const store = { data: {}, at: 0, busy: null, subs: new Set() };

// which game tiles have something waiting for the user (red dot); shared + throttled across all users of the hook
export function refreshGameBadges(force = false) {
  if (store.busy || (!force && Date.now() - store.at < 30000)) return store.busy;
  store.busy = Promise.all(["/wheel", "/ai/quiz", "/treasure/today", "/scratch", "/duels", "/heart", "/mood", "/megaheart", "/lotto", "/vault"].map(get))
    .then(([wheel, quiz, treasure, scratch, duels, heart, mood, mega, lotto, vault]) => {
      store.data = {
        "fun-tile-wheel": !!wheel?.available,
        "fun-tile-quiz": !!quiz && !quiz.done,
        "fun-tile-treasure": !!treasure && treasure.found < treasure.total,
        "fun-tile-scratch": (scratch?.open?.length || 0) > 0,
        "fun-tile-duels": (Array.isArray(duels) ? duels : duels?.duels || []).some((d) => d.status === "pending" && d.incoming),
        "fun-tile-heart": !!heart?.chain?.is_holder,
        "fun-tile-mood": !!mood && !mood.mine,
        "fun-tile-megaheart": !!mega && !mega.done && !mega.tapped_today,
        "fun-tile-vault": (vault?.keys?.left || 0) > 0,
        "fun-tile-lotto": !!lotto && !(lotto.tickets || []).length,
      };
      store.at = Date.now();
      store.subs.forEach((f) => f(store.data));
    })
    .finally(() => { store.busy = null; });
  return store.busy;
}

export function useGameBadges(refreshKey) {
  const [b, setB] = useState(store.data);
  useEffect(() => {
    store.subs.add(setB);
    const onPoints = () => setTimeout(() => refreshGameBadges(true), 1500);
    window.addEventListener(POINTS_EVENT, onPoints);
    return () => { store.subs.delete(setB); window.removeEventListener(POINTS_EVENT, onPoints); };
  }, []);
  useEffect(() => { refreshGameBadges(); }, [refreshKey]);
  return b;
}
